<template>
    <div class="layout-footer">
        <div @click="handleClick(item)" :class="{ active: item.path === $route.meta.name }" v-for="item in menus" >
            <img :src="item.path === $route.meta.name ? item.activeIcon : item.icon" alt=""></img>

            <span>{{ item.title }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'layout-footer',
    data() {
        return {
        }
    },
    computed: {
        menus() {
            return [
                {
                    icon: require('../assets/img/layout/icon-home.png'),
                    activeIcon: require('../assets/img/layout/icon-home-active.png'),
                    title: this.$t('menu.home'),
                    path: 'home',
                },
                {
                    icon: require('../assets/img/layout/icon-node.png'),
                    activeIcon: require('../assets/img/layout/icon-node-active.png'),
                    title: this.$t('menu.node'),
                    path: 'node',
                    active: true
                },
                {
                    icon: require('../assets/img/layout/icon-exchange.png'),
                    activeIcon: require('../assets/img/layout/icon-exchange-active.png'),
                    title: this.$t('menu.exchange'),
                    path: 'exchange',
                    active: true
                },
                {
                    icon: require('../assets/img/layout/icon-defi.png'),
                    activeIcon: require('../assets/img/layout/icon-defi-active.png'),
                    title: this.$t('menu.defi'),
                    path: 'defi',
                    active: true
                },
                {
                    icon: require('../assets/img/layout/icon-staking.png'),
                    activeIcon: require('../assets/img/layout/icon-staking-active.png'),
                    title: this.$t('menu.staking'),
                    path: '',
                    active: true
                },
                {
                    icon: require('../assets/img/layout/icon-me.png'),
                    activeIcon: require('../assets/img/layout/icon-me-active.png'),
                    title: this.$t('menu.me'),
                    path: 'me',
                    active: true
                }
            ]
        }
    },
    mounted() {

    },
    methods: {
        handleClick(item) {
            if (!item.path) return;
            this.$router.push({
                name: item.path,
                query:{share:this.$store.state.shareaddr}
            })
        }
    },

}
</script>

<style lang="less">
.layout-footer {
    position: fixed;
    z-index: 30;
    height: 82px;
    max-width: 375px;
    display: flex;
    box-shadow: 0px -1px 4px 0px rgba(58, 45, 45, 0.1);
    bottom: 0;
    width: 100%;
    background: #151515;
    align-items: flex-end;
    padding-bottom: 23px;

    >div {
        padding-top: 13px;
        flex: 1;
        // justify-content: center;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;

        img {
            width: 24px;
            height: 24px;
            margin-bottom: 6px;
        }

        span {
            color: #fff;
            font-size: 12px;
            opacity: 0.6;
            line-height: 16px;
        }



        &.active {
            padding-top: 0;

            span {
                opacity: 1;
                color: #05B9D0;
            }
        }
    }
}
</style>